import {
    ApplicationRef,
    ComponentFactoryResolver,
    Directive,
    ElementRef,
    EmbeddedViewRef,
    Host,
    Injector,
    Input,
    Optional,
    Self
} from '@angular/core';
import {Menu} from 'primeng/menu';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {IconDefinition, IconName} from '@fortawesome/fontawesome-svg-core';

/**
 * This directive allows to use fontawesome icons in a p-menu, the same way prime ng icons are normally used. When defining the menu items, just add
 * the fontawesome icons with the fa- prefix, and add this directive to the p-menu.
 *
 * If you want to use icons that are not part of the fontawesome basic icon set, you can provide them via the customIcons input property
 *
 * NOTE: Make sure that the menu items are defined before the menu is opened. Otherwise the icons are not properly displayed
 * */

@Directive({
    selector: 'p-menu[fontawesomeIcons]'
})
export class PMenuFontawesomeDirective {

    @Input() customIcons: IconDefinition[] = [];

    constructor(@Host() @Self() @Optional() public menu: Menu, private el: ElementRef, private resolver: ComponentFactoryResolver, private injector: Injector, private appRef: ApplicationRef) {
        let nativeShowFn = menu.show.bind(menu);
        menu.show = (event) => {
            nativeShowFn(event);
            // wait for menu to render before querying its content
            setTimeout(() => {
                document.querySelectorAll('.p-menu .p-menuitem-icon').forEach(e => {
                    let classes = Array.from(e.classList) as Array<string>;//.find(e => e.indexOf('fa-') !== -1);
                    let icon = classes.find(c => c.includes('fa-'));
                    if (icon) {
                        const factory = resolver.resolveComponentFactory(FaIconComponent);
                        const comp = factory.create(injector);
                        const iconName = icon.replace('fa-', '') as IconName;
                        comp.instance.icon = this.customIcons.find(s => s.iconName === iconName) ?? iconName;
                        appRef.attachView(comp.hostView);
                        const domElem = (comp.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
                        comp.instance.render();
                        e.appendChild(domElem);
                    }
                });
            });
        };

    }
}
